import React from "react";
import Header from "../../Header/Header";
import StrategyAssessmentMainOne from "./StrategyAssessmentMainOne";

const StrategyAssesmentOneBody = () => {

    return (
        <div id="strategyAssesmentOne">
            <Header
                title={"Strategy Assessment"}
                domId="strategyAssesmentOne"
            />
            <StrategyAssessmentMainOne />

          
        </div>
    );
};

export default StrategyAssesmentOneBody;






// <div className="">
// <div className="row mx-0">
//     <div className="col-5">{/* <img src="" alt="" /> */}</div>
//     <div className="col-7 border sh">
//         <h1 className="text-center">Your Profile</h1>
//         <div className="row mx-0 text-center p-2">
//             <div className="col-12 bg-danger my-2">
//                 <h2>Your Name</h2>
//                 <p>Entreprenuer Name</p>
//             </div>

//             <div className="col-6 my-2">
//                 <div className="bg-warning">
//                     <h2>Demo</h2>
//                     <p>Text</p>
//                 </div>
//             </div>
//             <div className="col-6 my-2">
//                 <div className="bg-success">
//                     <h2>Demo</h2>
//                     <p>Text</p>
//                 </div>
//             </div>
//             <div className="col-6 my-2">
//                 <div className="bg-success">
//                     <h2>Demo</h2>
//                     <p>Text</p>
//                 </div>
//             </div>
//             <div className="col-6 my-2">
//                 <div className="bg-success">
//                     <h2>Demo</h2>
//                     <p>Text</p>
//                 </div>
//             </div>
//             <div className="col-6 my-2">
//                 <div className="bg-success">
//                     <h2>Demo</h2>
//                     <p>Text</p>
//                 </div>
//             </div>
//             <div className="col-6 my-2">
//                 <div className="bg-success">
//                     <h2>Demo</h2>
//                     <p>Text</p>
//                 </div>
//             </div>
//             <div className="col-6 my-2">
//                 <div className="bg-success">
//                     <h2>Demo</h2>
//                     <p>Text</p>
//                 </div>
//             </div>
//             <div className="col-6 my-2">
//                 <div className="bg-success">
//                     <h2>Demo</h2>
//                     <p>Text</p>
//                 </div>
//             </div>
//         </div>
//     </div>
// </div>
// </div>